import React from 'react';
import PropTypes from 'prop-types';

function Teaser(props) {
  const {
    title,
    institution,
    sector,
    uuid,
    basePath,
    isNew,
  } = props;
  const link = basePath + uuid;
  const newIndicator = isNew ? (
    <span className="technical-service-teaser__new">Nueva</span>
  ) : null;
  return (
    <div className="technical-service-teaser">
      <h3 className="technical-service-teaser__title">
        <a href={link}>{title}</a>
      </h3>
      <p className="technical-service-teaser__institution">
        {institution}
      </p>
      <p className="technical-service-teaser__sector">
        <strong>Sector de aplicación: </strong>
        {sector}
      </p>
      <a
        href={link}
        className="btn btn-accent-dark-green btn-radius technical-service-teaser__link"
      >
        VER MÁS
      </a>
      {newIndicator}
    </div>
  );
}

Teaser.propTypes = {
  title: PropTypes.string.isRequired,
  institution: PropTypes.string.isRequired,
  sector: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
};

Teaser.defaultProps = {
  isNew: false,
};

export default Teaser;
